import { Injectable, inject } from '@angular/core';
import { Database, get, objectVal, ref } from '@angular/fire/database';
import { environment } from '../../environments/environment';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { Subject, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgendaService {
  private database: Database = inject(Database);
  http = inject(HttpClient);
  listenerAgenda = new Subject();
  
  changeTemaAgenda(tema:string) {
    this.listenerAgenda.next(tema);
  }

  get listenerAgenda$ () {
    return this.listenerAgenda.asObservable();
  }

  cargar (anio: string, mes: string) {
    return this.http.post(environment.entradas.cargar, {anio: anio, mes: mes}).pipe(
      map((data:any) => {
        return data;
      })
    );
  }

  getEntradasPorTema (tema:string) {
    const referenciaTema = ref(this.database, `entrada/${tema}`);
    return referenciaTema
  }

  async validateCambioTema (key: string, tema: string) {
    let entradaEncontrada = false;
    
    const entradas = await Promise.all([
      get(ref(this.database, `/entrada/-KcOsYIoTX3wdcK4DMjF/${key}`)),
      get(ref(this.database, `/entrada/-KcOsYIkmr2FHgi4ubym/${key}`)),
      get(ref(this.database, `/entrada/-KcOsYIprL1TVCF2uyaO/${key}`)),
      get(ref(this.database, `/entrada/-KdfegAIz9pHjb6ak32K/${key}`))
    ]);

    for(let i in entradas) {
      let entrada = entradas[i].val();
      if(entrada != null && entrada.tema != tema) {
        console.log("entrada/" + entrada.tema + "/" + key);
        entradaEncontrada = entrada;
      } else {
        console.log("Entrada no encontrada");
      }
    }

    return entradaEncontrada;
  }
}
